import React, {ReactNode} from 'react';

interface StepRendererProps {
  step: number
  children?: ReactNode | ReactNode[]
}

function getStep(step: number, maxAllowed: number) {
  if (step < 0) return 0;
  if (step > maxAllowed) return maxAllowed;
  return step
}

const StepRenderer = ({step, children}: StepRendererProps) => {

  const arrChildren = React.Children.toArray(children);
  const realStep = getStep(step, arrChildren.length - 1);

  if (arrChildren.length === 0) return null;
  return (
    <>
      {arrChildren[realStep]}
    </>
  );
};

export default StepRenderer;